import { Info } from '@liveauctioneers/hammer-ui-core/icons';
import BidLimitExceededMessage from '@/components/BidLimitExceededMessage/BidLimitExceededMessage';
import Tooltip from '@liveauctioneers/caterwaul-components/lib/Tooltip/Tooltip';

type Props = {
    catalogId: number;
    sellerId: number;
};

const BidLimitExceededPopover = ({ catalogId, sellerId }: Props) => (
    <Tooltip
        placement="left"
        trigger={
            <Info
                color="primary"
                size="xs"
                style="fill"
            />
        }
    >
        <BidLimitExceededMessage
            catalogId={catalogId}
            sellerId={sellerId}
        />
    </Tooltip>
);

export default BidLimitExceededPopover;
